import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ImportantUserDetails from './important-user-details';
import ImportantUserDetailsDetail from './important-user-details-detail';
import ImportantUserDetailsUpdate from './important-user-details-update';
import ImportantUserDetailsDeleteDialog from './important-user-details-delete-dialog';

const ImportantUserDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ImportantUserDetails />} />
    <Route path="new" element={<ImportantUserDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<ImportantUserDetailsDetail />} />
      <Route path="edit" element={<ImportantUserDetailsUpdate />} />
      <Route path="delete" element={<ImportantUserDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ImportantUserDetailsRoutes;
